import React from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import { Row, Col } from "react-bootstrap";

import { Formik, Form } from "formik";
import Button from "../../../../shared/components/Buttons/Button";
import { deviceActions } from "../../../../redux/actions/device.action";
import SelectField from "../../../../shared/components/selectField/SelectField";
import InputTextField from "../../../../shared/components/inputTextField/InputTextField";
import { addPaymentDeviceSchema } from "../../../../shared/validationSchema/validationSchema";
import Topbar from "../../../../shared/components/topbar/Topbar";
import {
  buttonTypeConstants,
  buttonNameConstants,
  routesPathConstants,
  deviceConstants,
  EMPTY_STRING,
  systemConstants,
  toastType,
} from "../../../../constants";
import {
  createCompanyDynamicUrl,
  customToast,
  isSpinnerEnabled,
  setPayrilliumBaseUrl,
} from "../../../../shared/utility";
import SwitchButtonFormik from "../../../../shared/components/SwitchButton/SwitchButtonFormik";
import { initializeTerminalConfig } from "../../../../services";

//-------AddNewDevice component start here
const AddNewDevice = (props) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  //-------Props
  const {
    stores,
    addDevice,
    updateDevice,
    spinnerArray,
    checkDeviceStatus,
    connectPayrillium,
  } = props;
  //-------initial state for form
  const initialValues = {
    serialNumber: state?.data?.serialNumber || EMPTY_STRING,
    poiId: state?.data?.poiId || EMPTY_STRING,
    store: state?.data?.store.id || EMPTY_STRING,
    deviceType: state?.data?.deviceType || EMPTY_STRING,
    deviceUrl: state?.data?.deviceUrl || EMPTY_STRING,
    setupCode: state?.data?.setupCode || EMPTY_STRING,
    posId: systemConstants.POS_ID,
    certificates: state?.data?.certificates || EMPTY_STRING,
    merchantId: state?.data?.merchantId || EMPTY_STRING,
    merchantKeyId: state?.data?.merchantKeyId || EMPTY_STRING,
    merchantsecretKey: state?.data?.merchantsecretKey || EMPTY_STRING,
    mccCode: state?.data?.mccCode || EMPTY_STRING,
    isDemoMode: state?.data?.isDemoMode || false,
  };

  //-------handle submit for add new device form
  const handleSubmit = (data) => {
    const findStore = stores.find((store) => {
      if (store.id === data.store) {
        return {
          id: store.id,
          storeName: store.storeName,
        };
      }
    });
    const formData = {
      ...data,
      store: { id: findStore?.id, storeName: findStore?.storeName },
    };

    if (state?.isEdit) {
      updateDevice(state?.data?.id, formData);
    } else {
      addDevice(formData);
    }
  };

  //-------handle cancel button
  const handleCancelButton = () => {
    navigate(createCompanyDynamicUrl(routesPathConstants.ADMIN_DEVICES));
  };

  //-------check device status
  const handleCheckStatus = (serialNumber, deviceType) => {
    if (serialNumber) {
      checkDeviceStatus(serialNumber, deviceType);
    }
  };
  const handleConnectPayrillium = (values) => {
    if (!values.deviceUrl || !values.setupCode) {
      customToast("Device URL and setup code is required.", toastType.ERROR);
      return;
    } else if (!String(values.deviceUrl).startsWith("https://")) {
      customToast("Device URL is invalid", toastType.ERROR);
      return;
    }
    connectPayrillium(values);
  };
  const handleConfigureMerchantPayrillium = (data) => {
    if (
      !data.merchantId ||
      !data.merchantKeyId ||
      !data.merchantsecretKey ||
      !data.mccCode ||
      !data.deviceUrl
    ) {
      customToast("All Merchant fields are required.", toastType.ERROR);
      return;
    }
    initializeTerminalConfig(data);
  };

  return (
    <>
      <Topbar
        title={state?.isEdit ? "Edit Device" : "New Device"}
        backNavigation={{
          isVisible: true,
          route: routesPathConstants.ADMIN_DEVICES,
        }}
      />
      <Row className="m-0 p-0 w-100">
        <Formik
          initialValues={initialValues}
          validate={addPaymentDeviceSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue }) => (
            <Form className="m-0">
              <Row className="m-0">
                <Col md={6} className="mb-3">
                  <InputTextField
                    name="serialNumber"
                    label="Serial Number"
                    placeHolder="Enter Serial Number"
                  />
                </Col>
                <Col md={6} className="mb-3">
                  <InputTextField
                    name="poiId"
                    label="Nickname"
                    placeHolder="Enter Nickname"
                  />
                </Col>
                <Col md={6} className="mb-3">
                  <SelectField
                    label="Store"
                    name="store"
                    placeHolder={"Select Store"}
                    options={stores?.map((store) => ({
                      value: store.id,
                      label: store.storeName,
                    }))}
                  />
                </Col>
                <Col md={6} className="mb-3">
                  <SelectField
                    label="Device Type"
                    name="deviceType"
                    placeHolder={"Select Device Type"}
                    options={deviceConstants.DEVICE_TYPES?.map((type) => ({
                      value: type.value,
                      label: type.label,
                    }))}
                  />
                </Col>
                {/* Payrillium device fields */}
                {values.deviceType ===
                  deviceConstants.PAYMENT_DEVICE_TYPES.PAYRILLIUM && (
                  <>
                    <Col md={6} className="mb-3">
                      <InputTextField
                        name="merchantId"
                        placeHolder="Enter Merchant Id"
                        label="Merchant Id"
                      />
                    </Col>
                    <Col md={6} className="mb-3">
                      <InputTextField
                        name="merchantKeyId"
                        placeHolder="Enter Merchant Key Id"
                        label="Merchant Key Id"
                      />
                    </Col>
                    <Col md={6} className="mb-3">
                      <InputTextField
                        name="merchantsecretKey"
                        placeHolder="Enter Merchant Secret Key"
                        label="Merchant Secret Key"
                      />
                    </Col>
                    <Col md={6} className="mb-3">
                      <InputTextField
                        name="mccCode"
                        placeHolder="Enter MCC Code"
                        label="MCC Code"
                      />
                    </Col>
                    <Col md={6} className="mb-3 d-flex align-items-end">
                      <SwitchButtonFormik
                        setFieldValue={setFieldValue}
                        name="isDemoMode"
                        label="Demo Mode"
                        isChecked={values.isDemoMode}
                      />
                    </Col>
                    <Col md={6} className="mb-3">
                      <InputTextField
                        maxLength={500}
                        name="deviceUrl"
                        label="Device URL"
                        placeHolder="192.168.178.93"
                        handleChange={(e) => {
                          setPayrilliumBaseUrl(e);
                        }}
                      />
                    </Col>
                    {/* <Col md={6} className="mb-3">
                      <InputTextField
                        name="setupCode"
                        label="Setup Code"
                        placeHolder="Enter Setup Code"
                      />
                    </Col>
                    <Col md={6} className="mb-3">
                      <InputTextField
                        name="posId"
                        label="POS Id"
                        disabled={true}
                      />
                    </Col> */}
                  </>
                )}
                {/* Action buttons*/}
                <Row className="px-0 mx-0">
                  <Col
                    md={6}
                    className="d-flex justify-content-end align-items-end mb-3 gap-2"
                  >
                    {/* if verifone or connected PAYRILLIUM then show check status */}
                    {values.deviceType ===
                    deviceConstants.PAYMENT_DEVICE_TYPES.VERIFONE ? (
                      <Button
                        type="button"
                        className={`w-50 ${
                          !values.serialNumber && "disable-button"
                        }`}
                        label={buttonNameConstants.CHECK_STATUS}
                        handleClick={() =>
                          handleCheckStatus(
                            values.serialNumber,
                            values.deviceType
                          )
                        }
                        isDisabled={
                          !values.serialNumber ||
                          isSpinnerEnabled(
                            spinnerArray,
                            deviceConstants.ADD_DEVICE
                          ) ||
                          isSpinnerEnabled(
                            spinnerArray,
                            deviceConstants.UPDATE_DEVICE
                          )
                        }
                      ></Button>
                    ) : values.deviceType ===
                      deviceConstants.PAYMENT_DEVICE_TYPES.PAYRILLIUM ? (
                      <>
                        <Button
                          type="button"
                          className={`w-50 `}
                          label={buttonNameConstants.CONFIGURE_MERCHANT}
                          handleClick={() =>
                            handleConfigureMerchantPayrillium(values)
                          }
                          isDisabled={false}
                        ></Button>
                        <Button
                          type="button"
                          className={`w-50`}
                          label={buttonNameConstants.CHECK_STATUS}
                          handleClick={() =>
                            handleCheckStatus(
                              values.serialNumber,
                              values.deviceType
                            )
                          }
                          isDisabled={!values.deviceUrl}
                        ></Button>
                        {/* <Button
                          type="button"
                          className={`w-50 `}
                          label={buttonNameConstants.CONNECT_PAYRILLIUM}
                          handleClick={() => handleConnectPayrillium(values)}
                          isDisabled={false}
                        ></Button> */}
                      </>
                    ) : (
                      <></>
                    )}
                  </Col>
                  <Col md={6} className="mb-3 d-flex gap-2">
                    <Button
                      type="button"
                      label={buttonNameConstants.CANCEL}
                      handleClick={() => {
                        handleCancelButton();
                      }}
                      buttonType={buttonTypeConstants.GHOST_BUTTON}
                      className="w-100"
                      isDisabled={
                        isSpinnerEnabled(
                          spinnerArray,
                          deviceConstants.ADD_DEVICE
                        ) ||
                        isSpinnerEnabled(
                          spinnerArray,
                          deviceConstants.UPDATE_DEVICE
                        )
                      }
                    ></Button>
                    <Button
                      type="submit"
                      className="w-100"
                      label={
                        state?.isEdit
                          ? buttonNameConstants.UPDATE
                          : buttonNameConstants.SAVE
                      }
                      isDisabled={
                        isSpinnerEnabled(
                          spinnerArray,
                          deviceConstants.ADD_DEVICE
                        ) ||
                        isSpinnerEnabled(
                          spinnerArray,
                          deviceConstants.UPDATE_DEVICE
                        )
                      }
                    ></Button>
                  </Col>
                </Row>
              </Row>
            </Form>
          )}
        </Formik>
      </Row>
    </>
  );
}; //-------AddNewDevice component end here

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  stores: state.store.stores,
  spinnerArray: state.system.spinnerArray,
  company: state.authentication.company,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  addDevice: (data) => dispatch(deviceActions.addDevice(data)),
  checkDeviceStatus: (serialNumber, deviceType) =>
    dispatch(deviceActions.checkDeviceStatus(serialNumber, deviceType)),
  updateDevice: (id, data) => dispatch(deviceActions.updateDevice(id, data)),
  connectPayrillium: (data) => dispatch(deviceActions.connectPayrillium(data)),
});

//-------Export AddNewDevice Component
export default connect(mapStateToProps, mapDispatchToProps)(AddNewDevice);
